import api, {
  setHeaderToken,
  removeHeaderToken
} from '../../../apis/Api';

import router from '@/router'

export default {
  namespaced: true,
  state: {
    defaultRoleAccess: [],
    roleName: "",
    DCLocations: [],
    menuActive: "",
    userLog: []
  },
  getters: {
    getDefaultRoleAccess(state) {
      return state.defaultRoleAccess;
    },
    getRoleName(state) {
      return state.roleName;
    },
    getDCLocations(state) {
      return state.DCLocations;
    },
    getMenuActive(state) {
      return state.menuActive;
    },
    getUserLog(state) {
      return state.userLog;
    },

  },
  mutations: {
    setDefaultRoleAccess(state, payload) {
      state.defaultRoleAccess = payload;
    },
    setRoleName(state, payload) {
      state.roleName = payload;
    },
    setDCLocations(state, payload) {
      state.DCLocations = payload;
    },
    setMenuActive(state, payload) {
      state.menuActive = payload;
    },
    setUserLog(state, payload) {
      state.userLog = payload;
    },
  },
  actions: {
    getDefaultRoleAccess({
      state,
      commit,
      dispatch,
      rootGetters
    }, payload) {
      // dispatch('setLoading', true)
      let token = localStorage.getItem("token");
      api({
        method: "post",
        url: `role/access/default`,
        headers: {
          'Authorization': 'Bearer ' + token,
        }
      }).then((res) => {
        if (res.respond.status == "success") {
          commit("setRoleName", res.respond.RoleName);
          commit("setDefaultRoleAccess", res.respond.data);
        }
        // dispatch('setLoading', false)
      }).catch((err) => {
        console.log('authjs=err' + err)
        // dispatch('setLoading', false)
        return false
      })
    },
    getDCLocations({
      state,
      commit,
      dispatch,
      rootGetters
    }, payload) {
      // dispatch('setLoading', true)
      let token = localStorage.getItem("token");
      api({
        method: "get",
        url: `location/area/branch`,
        headers: {
          'Authorization': 'Bearer ' + token,
        }
      }).then((res) => {
        if (res.respond.status == "success") {
          commit("setDCLocations", res.respond.data);
        }
        // dispatch('setLoading', false)
      }).catch((err) => {
        console.log('authjs=err' + err)
        // dispatch('setLoading', false)
        return false
      })
    },

    getUserLog({
      state,
      commit,
      dispatch,
      rootGetters
    }, payload) {
      // dispatch('setLoading', true)
      let token = localStorage.getItem("token");
      api({
        method: "get",
        url: `log/user`,
        params: payload,
        headers: {
          'Authorization': 'Bearer ' + token,
        }
      }).then((res) => {
        if (res.respond.status == "success") {
          commit("setUserLog", res.respond.data);
        }
        // dispatch('setLoading', false)
      }).catch((err) => {
        console.log('authjs=err' + err)
        // dispatch('setLoading', false)
        return false
      })
    },

    setLoading({
      commit
    }, payload) {
      commit("loader/setLoading", payload, {
        root: true,
      });
    },
  },
};